export enum SaleChannel {
	
	EXTERNAL = "EXTERNAL" ,
	DEALER = "DEALER" 

}

